import { useEffect, useState } from 'react';

import getConfig from 'next/config';
import * as braze from '@braze/web-sdk';
import { useAuth } from '../state';
import shallow from 'zustand/shallow';
import { checkIsBrowser } from '@alpha.apps/react-common';

const BrazeApiKey = getConfig().publicRuntimeConfig.brazeApiKey as string;
const BrazeSdkEndpoint = 'sdk.fra-02.braze.eu';

export const useBraze = () => {
  const [_braze, setBraze] = useState<typeof braze>(null);
  const user = useAuth(s => s.user, shallow);

  useEffect(() => {
    if (!checkIsBrowser()) return;
    // if (!!_braze || !user?.token) return;
    if (!user?.token) return;

    if (braze.isPushSupported()) {
      braze.requestPushPermission();
    }

    braze.initialize(BrazeApiKey, {
      baseUrl: BrazeSdkEndpoint,
      serviceWorkerLocation: '/BrazeSDKWorker.js',
    });

    // optionally show all in-app messages without custom handling
    braze.automaticallyShowInAppMessages();

    setBraze(braze);

    braze.subscribeToContentCardsUpdates(function (cards) {
      // console.log('cards', cards);
      // cards have been updated
    });
    // optionally set the current user's external ID before starting a new session
    // you can also call `changeUser` later in the session after the user logs in
    braze.changeUser(user.id.toString());
    // braze.getUser().setCustomUserAttribute('firstName', user.firstName);
    // braze.getUser().setEmail(user.email);
    // braze.getUser().setFirstName(user?.firstName);

    braze.subscribeToInAppMessage(function (inAppMessage) {
      // control group messages should always be "shown"
      // this will log an impression and not show a visible message
      if (inAppMessage instanceof braze.ControlMessage) {
        return braze.showInAppMessage(inAppMessage);
      }

      if (inAppMessage instanceof braze.InAppMessage) {
        const extras = inAppMessage.extras;
        if (extras) {
          for (const key in extras) {
            console.log('key: ' + key + ', value: ' + extras[key]);
          }
        }
      }
      braze.showInAppMessage(inAppMessage);
    });

    // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
    braze.openSession();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_braze, user]);

  return {};
};
